import { useTranslation } from 'react-i18next'
import { Modal } from '~/shared/ui/Modal'
import { Description, Title } from './styled'

type RejectInspectionModal = {
  isShow: boolean
  onClose: () => void
  onOk: () => void
}

export function RejectInspectionModal({
  isShow,
  onClose,
  onOk,
}: RejectInspectionModal) {
  const { t } = useTranslation()

  return (
    <Modal
      isShow={isShow}
      onCancel={onClose}
      onOk={onOk}
      cancel={t('button.no')}
      ok={t('button.yes')}
      canBackdropClose={false}
      reverseButton
    >
      <Title>{t('alert.do you want to abort the inspection?')}</Title>
      <Description>
        {t('alert.once you abort the inspection, the data will not be saved')}
      </Description>
    </Modal>
  )
}
